import axios from "axios";
import { toast } from "react-toastify";
import { extractCountryCode, getCurrencyData } from "../../../utils/utility";
import { environmentVariables } from "../../../config/env.config";

const getLatLongWithoutHook = () => {
  return new Promise((resolve) => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        resolve({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        });
      },
      () => {
        resolve({
          latitude: 28.58224,
          longitude: 77.3245594,
        });
      }
    );
  });
};

const getOSName = () => {
  const platform = navigator.platform.toLowerCase();
  if (platform.includes("win")) return "Windows";
  if (platform.includes("mac")) return "macOS";
  if (platform.includes("linux")) return "Linux";
  return "Windows";
};
const getBrowserName = () => {
  const ua = navigator.userAgent;
  if (ua.includes("Chrome")) return "Chrome";
  if (ua.includes("Firefox")) return "Firefox";
  if (ua.includes("Safari")) return "Safari";
  return "Chrome";
};

export const createOrder = async (values, rs, t) => {
  console.log("Payment submitted:separate,IN ,,12", values);

  // const { latitude, longitude } = getLatLong();
  const { latitude, longitude } = await getLatLongWithoutHook();
  const browser = getBrowserName();
  const os = getOSName();

  let contactInfo = JSON.parse(rs?.contactInfo?.content)
  let {code , number} = extractCountryCode(contactInfo?.contactInfoPhone)
  let getUserData = JSON.parse(localStorage.getItem("Customer"));
  let userEmail, userContactNumber, userContactCode, userName;
  if(getUserData){
    userEmail = getUserData?.email?.trim()
    userContactNumber = getUserData?.contact?.trim()
    userContactCode = getUserData?.country_code?.trim()
    userName = getUserData?.name?.trim()
  }else{
    userEmail = contactInfo?.contactInfoEmail?.trim()
    userContactNumber = number?.trim()
    userContactCode = code?.trim()
    userName = rs?.title?.trim()
  }
  // console.log(latitude, longitude, browser, os, "ddddddddddddddddddddddddddd", rs,contactInfo);
  try {
    const response = await axios.request({
      method: "post",
      url: `${environmentVariables?.apiUrl}api/v1/custompayment/create_custom_payment_order_paypoint`,
      withCredentials: true,
      data: {
        business_id: rs?.id,
        customer_name: userName,
        customer_email: userEmail,
        phone:  userContactNumber,
        phone_code: userContactCode,
        message: `Amount of ${getCurrencyData(rs?.shipCountry)} ${Number(values?.amountForCustomePay)?.toFixed(2)} initiated`,
        address: contactInfo?.contactInfoAddress?.trim(),
        amount: Number(values?.amountForCustomePay)?.toFixed(2),
        currency: getCurrencyData(rs?.shipCountry),
        cURL: window.location.href,
        latitude: latitude,
        longitude: longitude,
        browser: browser,
        os: os,
        user_id : rs?.created_by
      },
    });

    const dataResponse = response.data;
    console.log("dataResponse", dataResponse);

    if (dataResponse?.data) {
      return dataResponse;
    } else {
      toast.error(dataResponse?.message || "Error generating QR code", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 2000,
      });
      return null;
    }
  } catch (error) {
    console.log("error", error?.response?.data?.message);
    toast.error(error?.response?.data?.message || error?.message);
    // toast.error(error?.response?.data?.message || error?.message, {
    //   position: toast.POSITION.TOP_RIGHT,
    //   autoClose: 2000,
    // });
    return null;
  }
};


export const createRestaurantOrder = async (values, rs, t) => {
  console.log("Payment submitted:separate,IN ,,12", values);

  // const { latitude, longitude } = getLatLong();
  const { latitude, longitude } = await getLatLongWithoutHook();
  const browser = getBrowserName();
  const os = getOSName();

  const number_last = values?.phone;
  const number_first = values?.countryCode;

  console.log(latitude, longitude, browser, os, "ddddddddddddddddddddddddddd");
  try {
    const response = await axios.request({
      method: "post",
      url: `${environmentVariables?.apiUrl}api/v1/restaurant/create_restaurant_order_paypoint`,
      withCredentials: true,
      data: {
        business_id: rs?.id,
        customer_name: values?.username,
        customer_email: values?.user_email,
        phone: number_last,
        phone_code: number_first,
        address: values?.address,
        amount: Number(values?.totalAmount)?.toFixed(2),
        currency: getCurrencyData(rs?.shipCountry),
        cURL: window.location.href,
        latitude: latitude,
        longitude: longitude,
        browser: browser,
        os: os,
        ...values,
      },
    });

    const dataResponse = response.data;

    if (dataResponse?.data) {
      console.log("dataResponse", dataResponse);
      return dataResponse;
    } else {
      toast.error(dataResponse?.message || "Error generating QR code", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 2000,
      });
      return null;
    }
  } catch (error) {
    toast.error(error?.response?.data?.message || error?.message);
    return null;
  }
};

export const createRestaurantOrderPaylater = async (values, rs, t) => {
  console.log("Payment submitted:separate,IN ,,12", values);

  // const { latitude, longitude } = getLatLong();
  const { latitude, longitude } = await getLatLongWithoutHook();
  const browser = getBrowserName();
  const os = getOSName();
  console.log(latitude, longitude, browser, os, "ddddddddddddddddddddddddddd");
  try {
    const response = await axios.request({
      method: "post",
      url: `${environmentVariables?.apiUrl}api/v1/restaurant/create_restaurant_order_paypoint_paylater`,
      withCredentials: true,
      data: {
        order_id:values?.order_id,
        amount: Number(values?.totalAmount)?.toFixed(2),
        cURL: window.location.href,
        latitude: latitude,
        longitude: longitude,
        browser: browser,
        os: os,
        ...values,
      },
    });

    const dataResponse = response.data;

    if (dataResponse?.data) {
      console.log("dataResponse", dataResponse);
      return dataResponse;
    } else {
      toast.error(dataResponse?.message || "Error generating QR code", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 2000,
      });
      return null;
    }
  } catch (error) {
    toast.error(error?.response?.data?.message || error?.message);
    return null;
  }
};


export const createOrderForInfluencer = async (values, rs) => {
  console.log("Payment submitted:separate,IN ,,12", values);

  // const { latitude, longitude } = getLatLong();
  const { latitude, longitude } = await getLatLongWithoutHook();
  const browser = getBrowserName();
  const os = getOSName();

  console.log(latitude, longitude, browser, os, "ddddddddddddddddddddddddddd");
  try {
    const response = await axios.request({
      method: "post",
      url: `${environmentVariables?.apiUrl}api/v1/influencer/create_order`,
      withCredentials: true,
      data: {
        ...values,
        customer_name: values.user_name?.trim(),
        customer_email: values.user_email?.trim(),
        phone: values?.user_mobile,
        phone_code: values?.user_country_code,
        address: values?.billingAddressForCustomePay?.trim(),
        amount: Number(values?.total)?.toFixed(2),
        currency: getCurrencyData(values?.shipCountry),
        cURL: window.location.href,
        latitude: latitude,
        longitude: longitude,
        browser: browser,
        os: os,
      },
    });

    const dataResponse = response.data;

    if (dataResponse?.data) {
      console.log("dataResponse", dataResponse);
      return dataResponse;
    } else {
      toast.error(dataResponse?.message || "Error generating QR code", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 2000,
      });
      return null;
    }
  } catch (error) {
    toast.error(error?.response?.data?.message || error?.message);
    return null;
  }
};